import { Filter } from '@anytag/shared-molecules';
import { Template, TemplateProps } from './Template';
import { useMarketplaceJoinedInfluencersFilter } from './hooks';

type MarketplaceJoinedInfluencersFilterProps = Omit<TemplateProps, 'onSubmit'>;

export const MarketplaceJoinedInfluencersFilter = (props: MarketplaceJoinedInfluencersFilterProps) => {
  const { filter, setFilterForm } = useMarketplaceJoinedInfluencersFilter();

  return (
    <Filter.Provider onSubmit={setFilterForm} values={filter} className="rounded-none">
      <Template {...props} />
    </Filter.Provider>
  );
};

export { useMarketplaceJoinedInfluencersFilter };
export * from './schemaTypes';
